import React, { useEffect } from 'react'
import intl from 'react-intl-universal'
import { useEvidentlyFeatures } from '~/evidentlyFeatureFlags'
import { NEW_EDITOR_EXP } from '~/util/constants/keys'

export default function BlankTemplate({
  isOnlyOption = true,
  composerSettings,
}) {
  const [storyEditorHref, setHref] = React.useState(
    '/composer/story?template=default'
  )
  const flags = useEvidentlyFeatures()

  useEffect(() => {
    let v2Enabled = false
    const userEnabledNewEditor = window.localStorage.getItem(NEW_EDITOR_EXP)
    if (flags['v2-open-beta'] && composerSettings?.openBeta?.enabled) {
      if (userEnabledNewEditor === undefined || userEnabledNewEditor === null) {
        v2Enabled = composerSettings?.openBeta?.default ?? false
      } else {
        v2Enabled = userEnabledNewEditor === 'true'
      }
    }
    if (v2Enabled || flags['ui-v1-dropoff']) {
      setHref('/composer/story/v2/new')
    }
  }, [
    composerSettings?.openBeta?.default,
    composerSettings?.openBeta?.enabled,
    flags,
  ])

  return (
    <div
      data-testid="blank-template-option"
      className={isOnlyOption ? 'mb-3' : null}
    >
      <a href={storyEditorHref} className="dropdown-item p-0" target="_parent">
        <h6 className="dropdown-header p-2">
          <i className="fa fa-plus" />
          <span>{intl.get('search.template.blankTemplate')}</span>
        </h6>
      </a>
      <div className="dropdown-divider"></div>
    </div>
  )
}
